import { useEffect, useRef } from "react";

import PropTypes from "prop-types";
import { StyledCheckbox } from "./BaseCheckbox.styles";

const ControlledCheckbox = ({ checked, indeterminate, onChange, ...props }) => {
    const elRef = useRef();

    useEffect(() => {
        elRef.current.indeterminate = indeterminate;
    }, [indeterminate, checked]);

    const internalOnChange = (event) => {
        elRef.current.indeterminate = indeterminate;

        if (typeof onChange === "function") {
            onChange(event);
        }
    };

    return (
        <StyledCheckbox
            {...props}
            checked={checked}
            onChange={internalOnChange}
            type="checkbox"
            ref={elRef}
        />
    );
};

ControlledCheckbox.propTypes = {
    checked: PropTypes.bool,
    indeterminate: PropTypes.bool,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    isSmallSize: PropTypes.bool,
};

export default ControlledCheckbox;
